<template>
  <div class="sider" ref="scrollDiv">
    <!-- <div class="sider" :style="'margin-top:' + oldScrollTop+'px'" ref="scrollDiv"> -->
    <!-- 头部 -->
    <div class="siderTitle">
      <div style="margin-top:12px">
        <a-icon :component="IconAppstore" style="font-size: 24px;color:#1677FF;" />
        <span style="margin-left: 10px;margin-top: 10px" class="groupTitle">主题分类</span>
      </div>
    </div>
    <!-- 主题-->
    <a-menu class="menu-subject" mode="vertical" v-model="menu" @click="handleClick">
      <a-menu-item :key="item.iid" v-for="item in menuData">
        <span class="menu-title" v-if="oneThingList != null">
          <a :href=" oneThingList[item.iid] !== undefined ?'#' + item.iid : 'javascript:void(0)'" :style="checkSubjectId === item.iid?'color:#1890ff':'color:rgb(0 0 0 / 65%)'" >{{ item.subjectName }}</a>
        </span>
      </a-menu-item>
    </a-menu>
  </div>
</template>

<script>
import { jiopWebAPI } from '@/api/jiopweb/jiopweb'
import IconAppstore from '@ant-design/icons/svg/fill/appstore.svg?inline'
export default {
  data () {
    return {
      IconAppstore,
      menu: ['1'],
      menuData: [],
      totalData: [],
      oneThingServiceOb: 'personal',
      checkSubjectId: undefined,
      oneThingList: [],
      oldScrollTop: 0,
      maxHeight: 0,
      scrollDivHeight: 500,
      topHeight: 380,
      oldPosition: 0
    }
  },
  components: {

  },
  created () {
    // 缓存中没有用户信息时调用获取用户信息的接口
    if (!sessionStorage.getItem('JiopUserInfo') || !JSON.parse(sessionStorage.getItem('JiopUserInfo')).isLogin) {
      this.getLoginInfo()
    }
    this.loadSubject()
    setTimeout(() => {
      if (this.$refs.scrollDiv != null) {
        this.scrollDivHeight = this.$refs.scrollDiv.offsetHeight
        console.log(this.maxHeight)
      }
    }, 500)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.scrolling)
  },
  mounted () {
    // 监听页面滚动事件
    window.addEventListener('scroll', this.scrolling)
  },
  methods: {
    getLoginInfo () {
      jiopWebAPI
        .isLogin({ userType: 1, appType: 1 })
        .then(res => {
          if (res.success) {
            sessionStorage.setItem('JiopUserInfo', JSON.stringify(res.data))
            console.log('成功塞用户信息-onething')
          }
        })
    },
    scrolling (e) {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop// 兼容
      if (scrollTop - this.oldPosition >= 0) {
        if (scrollTop > this.topHeight) {
          // 超过头部再开始下移
          if (scrollTop < this.topHeight + this.maxHeight - this.scrollDivHeight) {
            // 未超过最大值
            this.oldScrollTop = scrollTop - this.topHeight + 10
          } else {
            // 超过最大值
            this.oldScrollTop = this.maxHeight - this.scrollDivHeight
          }
        }
      } else {
        if (scrollTop <= this.topHeight) {
          this.oldScrollTop = 0
        } else if (scrollTop > this.topHeight) {
          // 超过头部再开始下移
          if (scrollTop < this.topHeight + this.maxHeight - this.scrollDivHeight) {
            // 未超过最大值
            this.oldScrollTop = scrollTop - this.topHeight + 10
          } else {
            // 超过最大值
            this.oldScrollTop = this.maxHeight - this.scrollDivHeight
          }
        }
      }
      this.oldPosition = scrollTop
    },
    loadSubject () {
      // 一件事加载主题分类
      const that = this
      jiopWebAPI.findOneThingTheme({ serviceObj: this.oneThingServiceOb }).then(res => {
        if (res.success) {
          const list = res.data.themeList
          list.splice(0, 0, {
            iconUrl: '',
            iid: '',
            oneThingList: null,
            ordernum: 79,
            serviceObj: 'all',
            subjectItemType: 'onething',
            subjectName: '全部',
            subjectType: 'theme'
          })
          that.menuData = list
          that.totalData = list
          that.menu = [list[0].iid]
          that.checkSubjectId = list[0].iid
          that.$emit('load', that.menuData)
        }
      })
    },
    handleClick ({ item, key, keyPath }) {
      if (key === 'Yn6Fieq7cet3h6val1cyn') {
        key = ''
      }
      this.checkSubjectId = key
      this.$emit('reLoadRight', key)
    }
  }
}
</script>

<style lang="less" scoped>
.sider{
  margin-left: 10px;
  width: 240px;
  min-height: 700px;
  border: 1px solid #eee;
  box-shadow: 0px 2px 15px 0px rgba(153,153,153,0.2);
}
.menu-title{
  width: 36px;
  height: 40px;

  font-size: 18px;
  text-align: center;
  line-height: 40px;
  font-weight: 400;
}
.menu-subject{
  width: 240px;
  text-align: center;
}
.groupTitle{
  width: 88px;
  height: 24px;

  font-size: 22px;
  color: #000000;
  line-height: 24px;
  font-weight: 500;
}
.siderTitle {
  text-align: center;
  height: 70px;
  line-height: 40px;
  border-top: 5px solid #1677FF;
  width: 240px;
}
</style>
